<template>
  <div>

    <!-- 面包屑导航 -->
    <el-breadcrumb separator=">">
      <el-breadcrumb-item>Devices</el-breadcrumb-item>
      <el-breadcrumb-item>筛选设备</el-breadcrumb-item>
    </el-breadcrumb>
    <el-divider></el-divider>

    <div class="filter">
      <el-row :gutter="12">
        <!-- 1. 选择车型 -->

        <el-col :span="12">

          <span style="width: 100px;border: 0px solid black; display: inline-block;">选择车型:</span>


          <el-radio-group v-model="bikeType">
            <el-radio-button label="pad">pad</el-radio-button>
            <el-radio-button label="app">app</el-radio-button>
            <el-radio-button label="all">all</el-radio-button>
            <el-radio-button label="xbike">xbike</el-radio-button>
            <el-radio-button label="litbike">litbike</el-radio-button>
            <el-radio-button label="boombike">boom</el-radio-button>
            <el-radio-button label="boombasic">b-basic</el-radio-button>
            <el-radio-button label="ebike">ebike</el-radio-button>
            <el-radio-button label="other">other</el-radio-button>
          </el-radio-group>

        </el-col>

        <!-- 2. 选择激活时间 -->
        <el-col :span="12">

          <span style="width: 100px;border: 0px solid black; display: inline-block;">激活日期:</span>
          <el-select v-model="activateDateType" placeholder="选择" style="width: 100px">
            <el-option label="早于" value="before"></el-option>
            <el-option label="晚于" value="after"></el-option>
            <el-option label="介于" value="between"></el-option>
            <el-option label="不限" value="any"></el-option>
          </el-select>

          <!-- 根据激活时间类型动态展示日期选择器 -->

            <el-date-picker  v-if ="activateDateType === 'between'"     v-model="activateDateRange" type="daterange" start-placeholder="开始日期" end-placeholder="结束日期"
              range-separator="-" value-format="yyyy-MM-dd"     :default-time="['00:00:00', '23:59:59']">
            </el-date-picker>
  
            <el-date-picker  v-else   v-model="activateDate" type="date" placeholder="选择日期"   value-format="yyyy-MM-dd"     >
            </el-date-picker>
   

        </el-col>
      </el-row>

      <el-row :gutter="12">
        <!-- 3. 当前状态 -->
        <el-col :span="12">
          <div>
            <span style="width: 100px;border: 0px solid black; display: inline-block;">当前状态是:</span>
            <el-radio-group v-model="currentStatus">
              <el-radio-button label="unlinked">未试用</el-radio-button>
              <el-radio-button label="trial">试用中</el-radio-button>
              <el-radio-button label="failed">转化失败</el-radio-button>
              <el-radio-button label="subs">付费中</el-radio-button>
              <el-radio-button label="churned">流失中</el-radio-button>
              <el-radio-button label="all">任意</el-radio-button>
            </el-radio-group>
          </div>
        </el-col>

        <!-- 4. 绑卡日期 -->
        <el-col :span="12">
          <div>
            <span style="width: 100px;border: 0px solid black; display: inline-block;">绑卡日期:</span>

            <el-select v-model="bindingDateType" placeholder="选择" style="width: 100px">
              <el-option label="早于" value="before"></el-option>
              <el-option label="晚于" value="after"></el-option>
              <el-option label="介于" value="between"></el-option>
              <el-option label="不限" value="any"></el-option>
              <el-option label="从未绑卡" value="never"></el-option>
            </el-select>
            <!-- 根据绑卡时间类型动态展示日期选择器 -->

            <el-date-picker  v-if="bindingDateType === 'between'"  v-model="bindingDateRange" type="daterange" start-placeholder="开始日期" end-placeholder="结束日期"
              range-separator="-" value-format="yyyy-MM-dd" >
            </el-date-picker>
  
            <el-date-picker  v-else  v-model="bindingDate" type="date" placeholder="选择日期" value-format="yyyy-MM-dd"   >
            </el-date-picker>

          </div>
        </el-col>
      </el-row>

      <el-row :gutter="12">
        <el-col :span="12">
          <!--  与用户号关联 -->

          <span style="width: 100px;border: 0px solid black; display: inline-block;">关联用户:</span>
          <el-input v-model="users" placeholder="输入用户号或者邮箱,可以用逗号分隔多个"
            style="width: 500px;border: 0px solid black; display: inline-block;"></el-input>

        </el-col>
        <!-- 5. 是否白名单 -->
        <el-col :span="12">
          <div>
            <span style="width: 100px;border: 0px solid black; display: inline-block;">排除白名单：</span>

            <el-checkbox v-model="excludeWhite"></el-checkbox>
          </div>
        </el-col>
      </el-row>



      <el-row :gutter="12">
        <el-col :span="20"></el-col>
        <el-col :span="4">
          <el-button type="primary" @click="filterDevice">Filter Devices</el-button>
        </el-col>

      </el-row>
    </div>

    <!-- 表格 -->
    <el-table :data="tableData" stripe style="width: 100%" height="750"
      :default-sort="{ prop: 'id', order: 'descending' }">
      <el-table-column prop="id" label="序号" width="120" sortable></el-table-column>
      <el-table-column prop="deviceNumber" label="设备" width="220">

        <template slot-scope="scope">
  <!-- 使用 router-link 实现点击跳转 -->
  <router-link :to="{ name: 'deviceInfo', query: { deviceNumber: scope.row.deviceNumber }}" target="_blank">
    {{ scope.row.deviceNumber }}
  </router-link>
</template>

      </el-table-column>
      <el-table-column prop="keyUser" label="主账号" width="180"></el-table-column>
      <el-table-column prop="type" label="车型" width="110"></el-table-column>
      <el-table-column prop="activateDate" label="激活日期" sortable> </el-table-column>
      <el-table-column prop="cardDate" label="绑卡日期" sortable> </el-table-column>
      <el-table-column prop="trialDate" label="试用日期" sortable> </el-table-column>
      <el-table-column prop="subsDate" label="首次付费日期" sortable> </el-table-column>
      <el-table-column prop="ifWhite" label="是否白名单" > </el-table-column>
      <el-table-column prop="status" label="当前状态"></el-table-column>
    </el-table>
  </div>
</template>


<script>
export default {
  data() {
    return {
      bikeType: 'pad',
      activateDateType: 'any',
      activateDate: '',
      activateDateRange: ['', ''], // 范围属性

      bindingDateType: 'any',
      bindingDate: '',
      bindingDateRange: ['', ''], // 范围属性

      currentStatus: 'all',
      excludeWhite: true,
      users: '',
      tableData: [],
    };
  },
  methods: {


    filterDevice() {
      // 在这里编写筛选设备的逻辑
     // console.log('filters', this.filters);
      const params = {
        bikeType: this.bikeType,
        activateDateType: this.activateDateType,
        activateDate: this.activateDate,
        activateDateFrom: this.activateDateRange[0],
        activateDateTo: this.activateDateRange[1],
        bindingDateType: this.bindingDateType,
        bindingDate: this.bindingDate,
        bindingDateFrom: this. bindingDateRange[0],
        bindingDateTo: this. bindingDateRange[1],

        currentStatus: this.currentStatus,
        excludeWhite: this.excludeWhite,
        users: this.users,

      };
      this.$http.get("/da/device_filter", { params }).then(response => {
        this.tableData = response.data.records;
        this.totalDevices = response.data.total;
      }).catch(error => {
        console.error('请求失败:', error);
        // 可以在这里处理错误，比如显示一个错误消息
      });
    },
  }
}
</script>

<style scoped>
.filter-item {
  margin-bottom: 20px;

  /* 设置边框为1px实线，您可以根据需要调整边框的颜色 */
  border: 1px solid #000;
}

.filter {
  /* 使容器内的所有元素靠左对齐 */
  text-align: left;

  /* 移除内边距 */
  padding: 0;

  /* 移除子元素的外边距，确保没有间距 */
  /* 注意：这里假设filter容器直接包含的子元素是需要设置的目标，如果结构更复杂，可能需要更精确的选择器 */
  >* {
    margin: 0;
  }
}

.el-col {
  margin-top: 10px;
  margin-bottom: 10px;
}
</style>